import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const horizontalSizeSelectorSelector = createSelector(testTargetOffersSelector, offers => offers.horizontalSizeSelector || Empty.Object);

export { horizontalSizeSelectorSelector };
